exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Ygy-P5-65RjwqZUI1bTXN,.XB2QMcDyYUMSsI7zyz14q{width:32px;height:32px;display:inline-block}html[dir] ._3Ygy-P5-65RjwqZUI1bTXN,html[dir] .XB2QMcDyYUMSsI7zyz14q{background-color:transparent}.XB2QMcDyYUMSsI7zyz14q{width:16px;height:16px}html[dir] .Bt-yklKNzwCP-gygiixiS{margin:10px}", ""]);

// exports
exports.locals = {
	"icon": "_3Ygy-P5-65RjwqZUI1bTXN",
	"extraSmallIcon": "XB2QMcDyYUMSsI7zyz14q",
	"iconDefault": "Bt-yklKNzwCP-gygiixiS"
};